import { styled } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { FilledColoredCircle } from "@/Components/v2/atoms/ColoredCircle/FilledColoredCircle";
import { SvgIconComponent } from "@mui/icons-material";

type StatusStyle = {
  color: string;
  textColor?: string;
  icon?: SvgIconComponent;
};
interface StatusLabelProps {
  label: string;
  style: StatusStyle;
}

const StyledBox = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "0.875rem",
  fontWeight: 600,
  padding: "4px 0",
  height: "26px",
}));

const IconWrapper = styled("span")<{ color: string }>(({ color }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "18px",
  height: "18px",
  lineHeight: 0,
  "& svg": {
    fontSize: "18px",
    color: color,
  },
}));

const CircleWrapper = styled("span")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "18px",
  height: "18px",
  lineHeight: 0,
});

export const StatusLabel: React.FC<StatusLabelProps> = ({ label, style }) => {
  const Icon = style.icon;

  return (
    <StyledBox>
      {Icon ? (
        <IconWrapper color={style.color}>
          <Icon />
        </IconWrapper>
      ) : (
        <CircleWrapper>
          <FilledColoredCircle color={style.color} size={10} />
        </CircleWrapper>
      )}
      <span style={{ color: style.textColor || "inherit" }}>{label}</span>
    </StyledBox>
  );
};

export default StatusLabel;
